export default __webpack_public_path__ + "static/N0076-b6361ac6d5af48c39a386c27c4ff9109.png";